<template>
    <div class="dynamic-list">
        <div v-for="(item, index) in modelValue" :key="index" class="price-row">
            <div class="field">
                <span class="label">币种</span>
                <el-select v-model="item.currency" filterable allow-create default-first-option placeholder="请选择币种">
                    <el-option v-for="currency in currencyList" :key="currency.code" :label="currency.name"
                        :value="currency.code"></el-option>
                </el-select>
            </div>
            <div class="field">
                <span class="label">原价（划线价）</span>
                <el-input-number v-model="item.price" :min="0" :precision="2"></el-input-number>
            </div>
            <div class="field">
                <span class="label">售价（实际扣款）</span>
                <el-input-number v-model="item.sale_price" :min="0" :precision="2"></el-input-number>
            </div>
            <el-button class="row-btn" type="danger" size="mini"
                @click="$emit('update:modelValue', modelValue.filter((_, i) => i !== index))">删除</el-button>
        </div>
        <el-button type="primary" plain size="small"
            @click="$emit('update:modelValue', [...modelValue, { currency: '', price: null, sale_price: null }])">
            添加币种价格
        </el-button>
    </div>
</template>

<script>
import commonApi from '../../../axios/api'

export default {
    name: 'PetPriceEditor',
    props: { modelValue: { type: Array, required: true } },
    emits: ['update:modelValue'],
    data() {
        return { currencyList: [] }
    },
    created() {
        commonApi.CurrencyList({ page: 1, limit: 200 }).then(res => {
            if (res.data.code == 200) this.currencyList = res.data.data.data || []
        })
    }
}
</script>

<style scoped>
.dynamic-list { width: 100%; }
.price-row { display: flex; gap: 10px; align-items: center; margin-bottom: 10px; }
.field { display: flex; width: 200px; flex-direction: column; gap: 5px; }
.label { color: #606266; font-size: 12px; line-height: 1.2; }
.row-btn { margin-top: 22px; }
</style>
